import { createFileRoute, Link } from "@tanstack/react-router";
import { Navbar } from "@/components/landing/Navbar";
import { FooterSection } from "@/components/landing/FooterSection";
import { INSURANCES } from "@/data/heallexa";

const SITE = "https://heallexa.com";

export const Route = createFileRoute("/insurance/")({
 head: () => {
 const title = "Browse Doctors by Insurance | Heallexa";
 const description =
 "Find in-network doctors and specialists that accept your insurance. Heallexa covers Aetna, Blue Cross Blue Shield, Cigna, UnitedHealthcare, Medicare, Medicaid, and more — searchable across 6.3 million verified U.S. providers.";
 const url = `${SITE}/insurance`;
 return {
 meta: [
 { title },
 { name: "description", content: description },
 { property: "og:title", content: title },
 { property: "og:description", content: description },
 { property: "og:url", content: url },
 { property: "og:type", content: "website" },
 { name: "twitter:title", content: title },
 { name: "twitter:description", content: description },
 ],
 links: [{ rel: "canonical", href: url }],
 scripts: [
 {
 type: "application/ld+json",
 children: JSON.stringify({
 "@context": "https://schema.org",
 "@type": "CollectionPage",
 name: title,
 description,
 url,
 isPartOf: { "@id": `${SITE}/#website` },
 about: { "@type": "Thing", name: "Health Insurance Plans" },
 breadcrumb: {
 "@type": "BreadcrumbList",
 itemListElement: [
 { "@type": "ListItem", position: 1, name: "Home", item: SITE },
 { "@type": "ListItem", position: 2, name: "Insurance", item: url },
 ],
 },
 }),
 },
 ],
 };
 },
 component: InsuranceIndex,
});

function InsuranceIndex() {
 return (
 <div className="min-h-screen bg-background">
 <Navbar />
 <main className="mx-auto max-w-6xl px-6 py-16">
 <header className="mb-10">
 <p className="text-sm font-medium text-primary mb-2">Heallexa Directory</p>
 <h1 className="text-4xl md:text-5xl font-semibold tracking-tight text-foreground">
 Browse Doctors by Insurance
 </h1>
 <p className="mt-4 text-muted-foreground max-w-2xl leading-relaxed">
 Find in-network providers that accept your plan across{" "}
 <strong className="text-foreground font-medium">{INSURANCES.length} major U.S. insurance carriers</strong>{" "}
 and government programs. Heallexa covers Aetna, Blue Cross Blue Shield, Cigna,
 UnitedHealthcare, Humana, Kaiser, Medicare, Medicaid, and more — all searchable
 across 6.3 million verified providers. Select your plan below to get started.
 </p>
 </header>

 <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
 {INSURANCES.map((i) => (
 <li key={i.id}>
 <Link
 to="/insurance/$slug"
 params={{ slug: i.id }}
 className="flex items-center gap-3 rounded-xl border border-border bg-card p-4 hover:border-primary/40 hover:bg-accent transition"
 >
 <span
 className="h-9 w-9 rounded-md flex items-center justify-center text-xs font-semibold text-white shrink-0"
 style={{ backgroundColor: i.color }}
 aria-hidden
 >
 {i.short.slice(0, 2).toUpperCase()}
 </span>
 <span className="text-sm font-medium text-foreground truncate">{i.name}</span>
 </Link>
 </li>
 ))}
 </ul>
 </main>
 <FooterSection />
 </div>
 );
}
